import { render, staticRenderFns } from "./PendingApprovalCount.vue?vue&type=template&id=6ea69af6"
import script from "./PendingApprovalCount.vue?vue&type=script&lang=js"
export * from "./PendingApprovalCount.vue?vue&type=script&lang=js"
import style0 from "./PendingApprovalCount.vue?vue&type=style&index=0&id=6ea69af6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports